$.fn.Calculator_FieldReset = function()
{
	var self = this;
	self.originalValue = self.find('input').val();
	
	return function(){
		self.find('.input-group-addon').on('click', function(){
			self.find('input').val(self.originalValue).trigger('change');
			return false;
		});
		return self;
	}();
};

$.fn.Calculator = function()
{
	var _calc = this;
	_calc.fields = {
		fee: _calc.find('input[name=calc-fee]'),
		tax: _calc.find('input[name=calc-tax]'),
		taxAmount: _calc.find('input[name=calc-tax-amount]'),
		taxTotal: _calc.find('input[name=calc-tax-total]'),
		tps: _calc.find('input[name=calc-tps]'),
		tpsAmount: _calc.find('input[name=calc-tps-amount]'),
		tvq: _calc.find('input[name=calc-tvq]'),
		tvqAmount: _calc.find('input[name=calc-tvq-amount]'),
		v: _calc.find('input[name=calc-v]'),
		vAmount: _calc.find('input[name=calc-v-amount]'),
		subtotal: _calc.find('input[name=calc-subtotal]'),
		total: _calc.find('input[name=calc-total]'),
		net: _calc.find('input[name=calc-reverse-net]'),
		brut: _calc.find('input[name=calc-reverse-brut]')
	};

	_calc.get_value = function(field)
	{
		return asFloat(field.val());
	};

	_calc.normalize = function(field, is_tax)
	{
		var value = asFloat(field.val());
		value = _calc.format(value, is_tax);
		field.val(value);
	};

	_calc.format = function(amount, is_tax)
	{
		if (is_tax == undefined){
			is_tax = false;
		}
		if (isNaN(amount)){
			amount = 0;
		}
		amount = amount.toLocaleString('fr-CA', {
			minimumFractionDigits: is_tax ? 1 : 2,
			maximumFractionDigits: is_tax ? 3 : 2
		});
		return amount;
	};

	_calc.run = function(event)
	{
		// normalize input
		var field = $(event.target);
		_calc.normalize(field, field.hasClass("tax-field"));

		// run calculations
		var base = _calc.get_value(_calc.fields.fee),
			tax = _calc.get_value(_calc.fields.tax),
			taxAmount = base*tax/100,
			taxTotal = base+taxAmount,
			tps = _calc.get_value(_calc.fields.tps),
			tvq = _calc.get_value(_calc.fields.tvq),
			v = _calc.get_value(_calc.fields.v),
			tpsAmount = taxTotal*tps/100,
			tvqAmount = taxTotal*tvq/100,
			vAmount = base*v/100,
			subtotal = base-vAmount,
			total = subtotal+tpsAmount+tvqAmount;

		// reverse calculation (thanks wolfram alpha)
		var net = _calc.get_value(_calc.fields.net),
			brut = 10000*net/(tvq*(tax+100)+tps*(tax+100)-100*(v-100));

		// display values in fields
		_calc.fields.taxAmount.val(_calc.format(taxAmount));
		_calc.fields.taxTotal.val(_calc.format(taxTotal));
		_calc.fields.tpsAmount.val(_calc.format(tpsAmount));
		_calc.fields.tvqAmount.val(_calc.format(tvqAmount));
		_calc.fields.vAmount.val(_calc.format(vAmount));
		_calc.fields.subtotal.val(_calc.format(subtotal));
		_calc.fields.total.val(_calc.format(total));
		_calc.fields.brut.val(_calc.format(brut));
	};

	_calc.setFee = function(new_fee)
	{
		_calc.fields.fee.val(new_fee).change();
	};

	return function()
	{
		_calc.find("input").on("change", _calc.run);
		_calc.find('.input-group.reset').each(function(){
			$(this).Calculator_FieldReset();
		});
		return _calc;
	}();
};
